import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Prevent browser from restoring scroll position
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

// Scroll to top on page load
const scrollToTop = () => {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};

window.addEventListener('load', scrollToTop);
window.addEventListener('beforeunload', scrollToTop);

// Also scroll to top immediately
scrollToTop();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
